module.exports = __webpack_public_path__ + "static/media/g_1612148202_c0de41e573e448418c975725fa4dfca8.0deec683.jpeg";